import React from 'react';
import { makeStyles } from 'tss-react/mui';
import clsx from 'clsx';
import HeaderContainer from './HeaderContainer';
import { HEADER_HEIGHT, MAIN_THEME } from '@styles';
import { CDN_URL } from '@utils';
import { getCurrentEnvironment } from '@utils/env-utils';
import { IFormFieldInputBaseProps } from '@components/form-fields';
import Logo from '@components/common/Logo';

const useStyles = makeStyles()(() => ({
  header: {
    left: 0,
    position: 'fixed' as const,
    right: 0,
    top: 0,
    zIndex: 20,
    textAlign: 'center',
  },
}));

const HeaderShell: React.FC<
  IFormFieldInputBaseProps & {
    children?: React.ReactNode;
  }
> = ({ className, style, children }) => {
  const { classes } = useStyles();

  const currentEnv = getCurrentEnvironment();

  return (
    <HeaderContainer
      className={clsx(classes.header, className)}
      style={style}
      height={HEADER_HEIGHT}
      background={MAIN_THEME.color.red}
    >
      <Logo
        alt={'UFA Logo'}
        src={
          currentEnv === 'staging'
            ? CDN_URL + '/images/testing-icon.png'
            : CDN_URL + '/images/logo-small-white.png'
        }
        height={79}
        width={82}
        horizontalPadding={67}
        verticalPadding={17}
      />
      {children}
    </HeaderContainer>
  );
};

export default HeaderShell;
